<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { UserProfilePermissionLevel } from '@/enums/UserProfilePermissionLevel'
import { checkPermissions } from '@/composable/useCheckPermissions'
import AddSubjectsImg from '@images/dashboard/add-subjects.png'
import BookIcon from '@images/dashboard/book-solid.svg'

const { mdAndUp } = useDisplay()
</script>

<template>
  <VCard class="elevation-5 flex-grow-1">
    <VRow
      no-gutters
      class="h-100"
    >
      <VCol
        cols="3"
        sm="6"
      >
        <div class="bg-image__stretch-to-right">
          <VImg
            :src="AddSubjectsImg"
            height="100%"
            min-height="250"
            :position="mdAndUp ? 'left top' : ''"
            cover
          />
        </div>
      </VCol>
      <VCol
        cols="9"
        sm="6"
        class="pa-4 d-flex flex-column justify-space-between"
      >
        <div class="d-flex flex-fill">
          <div class="d-flex flex-column justify-center">
            <h4 class="mt-3">
              {{ $t('pages.dashboard.add_subjects_card_header') }}
            </h4>
            <p class="text-body-2 my-3">
              {{ $t('pages.dashboard.add_subjects_card_text') }}
            </p>
          </div>
        </div>
        <div class="text-right">
          <VBtn
            :to="{ name: 'organisation.subjects-and-qualifications' }"
            class="submit-btn"
            tonal
            rounded="xl"
          >
            <template #prepend>
              <VImg
                :src="BookIcon"
                width="15"
              />
            </template>
            {{ $t(checkPermissions(UserProfilePermissionLevel.ADMIN) ? 'pages.dashboard.add_subjects_card_btn' : 'pages.dashboard.view_subjects_btn') }}
          </VBtn>
        </div>
      </VCol>
    </VRow>
  </VCard>
</template>

<style lang="scss" scoped>
.bg-image__stretch-to-right {
  width: calc(100% + 40px);
}
</style>
